
// var baseUrl = 'http://192.168.5.222:38088';




var isIE = false;
var uuidList = "";
var rotateH = 0;
var filepath = "";
var filelist = "";
var phi = 0;
var camidx = 0;
var bsUrl = 'http://127.0.0.1';
console.log('进入zheLin');
//初始化
export function Init() {
    // getStatus();
}


//检测设备状态
export function getStatus() {
    // console.log('调用判断状态');
    var res = new Promise((resolve,reject)=>{
        $.ajax({
            // url: baseUrl + "/video=status",
            url: bsUrl + ":38088" + "/video=status",
            type: "post",
            //此处需要注意的是要想获取ajax返回的值这个async属性必须设置成同步的，否则获取不到返回值  -todo 测试了下没这个问题
            async: true,
            //data : {"name":"xiaoli"},
            dataType: "json",
            success: function (data) {
                // res = data;
                resolve(data)
            },
        });
    })

    return res;
}


//获取条形码信息
export function getErWeiMa() {
    var params = "{\"roi\": {\"top\":\"0\",\"left\":\"0\",\"bottom\":\"1\",\"right\":\"1\"}, \"cutpage\":\"0\", \"binary\":\"0\"}";// 识别区域
    let res = null;
    $.ajax({
        type: "post",
        // url: baseUrl + "/imagepro=barcode",
        url: bsUrl + ":38088" + "/imagepro=barcode",
        dataType: "json",
        data: params,
        async: false,
        success: function (data) {
            res = data;
            // console.log(res)
        }
    });
    return res;
}


//获取文档照片
export function getDocPhoto() {
    let res = null;;
    // var params = {
    //     "cutpage":"1",
    //     "camidx": "0",
    //     "image_storage_info": {
    //         "xdpi": "2592",
    //         "ydpi": "1944",
    //         "jpg_quality": "100"
    //     },
    //     "image_process_info": {
    //         "cut_type": "1",
    //         "multi_object": "1",
    //         "rotate": "0",
    //         "fixed_width": "0",
    //         "fixed_height": "0",
    //         "split_page": "1",
    //         "reduce_shadow": "1",
    //         "color_type": "0",
    //         "remove_black_edge": "1",
    //         "rect_correct": "1",
    //         "document_type": "1"
    //     }
    // }
    // if (rotateH >0){
    //     params.image_process_info.rotate = (rotateH * 90).toString();
    // }
    // console.log(rotateH,'旋转角度系数')
    // console.log(params,'图片参数');
	var strStorageInfo = "{ \"xdpi\":\"200\", \"ydpi\":\"200\", \"jpg_quality\":\"60\" }";
	var strImageProcess = "{\"cut_type\":\"" + '0' + "\", \"multi_object\":\"0\", \"rotate\":\"" + '90' +  "\"}";
	var params = "{\"camidx\":\"" + '0' + "\",\"make_uuid\":\"1\",\"image_storage_info\":" + strStorageInfo + ",\"image_process_info\":" + strImageProcess + "}";
	var data = "{\"function\": \"grab_image\", \"params\": " + params + "}";
    $.ajax({
        // url: baseUrl + "/video=grabimage",
        url: bsUrl + ":38088" + "/video=grabimage",
        type: "post",
        async: false,//此处需要注意的是要想获取ajax返回的值这个async属性必须设置成同步的，否则获取不到返回值
        data: data,
        dataType: "json",
        success: function (data) {
            res = data;
            // res = JSON.parse(data);
        }
    });
    return res;
}


var timer = null;
export function BeginTimer() {
    if (timer == null) {
        timer = setInterval("GetSignImage()", 1000);
    }
}
//打开签名窗口
export function StartSign() {
    let res = null;
    var params = "{\"pos\": {\"top\":\"50\",\"left\":\"50\",\"width\":\"1150\",\"height\":\"650\"}}"; //
    // var url = baseUrl + "/sign=start";
    var url = bsUrl + ":38088" + "/sign=start"
    $.ajax({
        url: url,
        type: "post",
        async: false,//此处需要注意的是要想获取ajax返回的值这个async属性必须设置成同步的，否则获取不到返回值
        //data: JSON.stringify(params),
        data: params,
        dataType: "json",
        success: function (data) {
            res = data;
        }
    });
    return res;
}
//关闭签名
export function StopSign() {
    // var url = baseUrl + "/sign=stop";
    var url = bsUrl + ":38088" + "/sign=stop";
    $.ajax({
        type: "post",
        url: url,
        dataType: "json",
        // data: JSON.stringify(params),
        success: function (data) {

        }
    });
    if (timer != null) {
        clearInterval(timer);
        timer = null;
    }
}
//获取签名图像
export function GetSignImage() {
    let res = null;;
    // var url = baseUrl + "/sign=get";
    var url = bsUrl + ":38088" + "/sign=get";
    $.ajax({
        type: "post",
        url: url,
        dataType: "json",
        async: false,
        // data: params,
        success: function (data) {
            // res = JSON.parse(data);
            res = data;
        }
    });
    return res;
}


export function CloseDevice() {

    var camradio = document.getElementsByName("camidx");
    for (i = 0; i < camradio.length; i++) {
        if (camradio[i].checked)
            camidx = camradio[i].value;
    }

    if (isIE) //ie浏览器
    {
        showVideoOcx.StopPreview();
    }
    else {
        document.getElementById("streamimage").src = "http://127.0.0.1:38088/video=close&camidx=" + camidx.toString();
    }
}







// WEBPACK FOOTER //
// ./src/common/utils/zheLin.js